import { render, staticRenderFns } from "./NewFolderIcon.vue?vue&type=template&id=56e06e26&scoped=true"
import script from "./NewFolderIcon.vue?vue&type=script&lang=js"
export * from "./NewFolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e06e26",
  null
  
)

export default component.exports